import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

import { breakpoints } from '@/config/layout'
import { VisibleScrollbarStyle } from '@/styles/scrollbar'

export const ContentPagePaddingCSS = css<{
  noPadding?: boolean
}>`
  ${({ theme, noPadding }) => `

      ${
        noPadding
          ? `padding: 0;`
          : `
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6};
      padding-bottom: 0;

      @media ${breakpoints.s} {
          padding: ${theme.UI.SpacingPx.Space5} ${theme.UI.SpacingPx.Space6};
          padding-bottom: 0;
        }

        @media ${breakpoints.m} {
          padding: ${theme.UI.SpacingPx.Space8} ${theme.UI.SpacingPx.Space12};
          padding-bottom: 0;
        }

        @media ${breakpoints.l} {
          padding: ${theme.UI.SpacingPx.Space12} ${theme.UI.SpacingPx.Space20};
          padding-bottom: 0;
        }
          `
      }
      `}
`

const StContainer = styled.div<{
  backgroundColor?: string
  noPadding?: boolean
}>`
  height: 100%;
  width: 100%;
  overflow: auto;
  overflow-x: hidden;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  grid-template-areas:
    'header'
    'main';

  ${({ backgroundColor, theme }) => `
    background-color: ${backgroundColor || theme.Colors.Background.White};
    `}

  ${ContentPagePaddingCSS}
`

const StHeaderContainer = styled.div`
  grid-area: header;
  max-width: 100%;
  min-width: 0; /* allow header content to shrink inside grid */
  overflow: hidden; /* prevent child overflow from grid sizing */
`

const StContentContainer = styled.main<{
  showScrollbar?: boolean
  noScroll?: boolean
}>`
  grid-area: main;
  position: relative;
  max-width: calc(100vw + ${({ theme }) => theme.UI.SpacingPx.Space6});
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0;
  overflow-x: ${({ noScroll }) => (noScroll ? 'visible' : 'hidden')};
  overflow-y: ${({ noScroll }) => (noScroll ? 'visible' : 'auto')};

  margin-right: -${({ theme }) => theme.UI.SpacingPx.Space6} !important;
  padding-right: ${({ theme }) => theme.UI.SpacingPx.Space6};
  @media ${breakpoints.s} {
    margin-right: -${({ theme }) => theme.UI.SpacingPx.Space6} !important;
    padding-right: ${({ theme }) => theme.UI.SpacingPx.Space6};
  }

  @media ${breakpoints.m} {
    margin-right: -${({ theme }) => theme.UI.SpacingPx.Space12} !important;
    padding-right: ${({ theme }) => theme.UI.SpacingPx.Space12};
  }

  @media ${breakpoints.l} {
    margin-right: -${({ theme }) => theme.UI.SpacingPx.Space20} !important;
    padding-right: ${({ theme }) => theme.UI.SpacingPx.Space20};
  }

  ${({ noScroll }) => (noScroll ? null : VisibleScrollbarStyle)};
`
const AnimatedStContentContainer = motion(StContentContainer)

export { AnimatedStContentContainer, StContainer, StContentContainer, StHeaderContainer }
